// ================================================================
// Storage — لایه انتزاع برای ذخیره‌سازی
// ================================================================
// الان از localStorage استفاده می‌کنه.
// فردا فقط همین فایل رو تغییر می‌دیم تا به backend وصل بشه.

const STORAGE_KEY = 'make-clone:scenario';

export const storage = {
  /**
   * ذخیره state
   */
  save(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (err) {
      console.warn('Could not persist state:', err);
    }
  },

  /**
   * بارگذاری state
   */
  load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      console.warn('Could not load state:', err);
      return null;
    }
  },

  /**
   * پاک کردن
   */
  clear() {
    localStorage.removeItem(STORAGE_KEY);
  }

  // --------------------------------------------------------------
  // در آینده برای backend:
  // async save(data) {
  //   await fetch('/api/scenario', { method: 'POST', body: JSON.stringify(data) });
  // }
  // async load() {
  //   const res = await fetch('/api/scenario');
  //   return await res.json();
  // }
  // --------------------------------------------------------------
};
